import { InjectionToken, EventEmitter, Component, Input, Output, Injectable, ɵɵdefineInjectable, Inject, ɵɵinject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { of } from 'rxjs';
import { __awaiter } from 'tslib';
import { Router } from '@angular/router';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import Debug from 'debug';
import { OrderService } from '@modeso/giftcardshop-lib-order-fe';
import { take, tap, map, takeUntil, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { InjectedTextFeautureModule, NamedString, InjectedTextProvider } from '@modeso/modeso-lib-core-fe';
import { BehaviorSubject, Subject } from 'rxjs/';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/address.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModesoAddressConfig() { }
if (false) {
    /** @type {?} */
    ModesoAddressConfig.prototype.serviceId;
}
/** @type {?} */
const ModesoAddressConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/countriesJson.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CountriesJson = [
    { code: 'LI',
        name: {
            'de-ch': 'Fürstentum Liechtenstein',
            'fr-ch': 'Principauté du Liechtenstein',
            'it-ch': 'Principato del Liechtenstein'
        }
    },
    { code: 'CH',
        name: {
            'de-ch': 'Schweiz',
            'fr-ch': 'Suisse',
            'it-ch': 'Svizzera'
        },
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-details/address-details.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddressDetailsComponent {
    /**
     *
     * @param {?} fb
     */
    constructor(fb) {
        this.inputsValid = new EventEmitter();
        this.inputsData = new EventEmitter();
        this.alertMsg = new EventEmitter();
        this.fieldErrorFlags = {};
        /**
         * countries  dropdown list.
         * default:choose default country is switherland.
         */
        this.countries = [];
        this.default = 'CH';
        this.initializeAddressForm(fb);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.countries = CountriesJson;
        this.onChanges();
        this.emitInputsValid();
        this.emitInputsData();
        this.insertAddressFormData();
    }
    /**
     * address form to insert initial data and validation.
     * @param {?} fb
     * @return {?}
     */
    initializeAddressForm(fb) {
        /** @type {?} */
        const allowedCharacters = 'A-Za-z \\-ÁáÀàÅåÃãÄäÂâĆćÇçĈĉḐḑÉéÈèËëÊêĢģĜĝĤĥÍíÌìĨĩÏïÎîĴĵḰḱĶķĹĺĻļŃńŅņÑñÓóÒòØøÕõÔôŔŕŖŗŚśŞşŜŝŢţÚúÙùŨũÛûŴŵÝýŸÿŶŷŹźÆæŒœ»«ÖöüÜ\'`';
        this.addressForm = fb.group({
            company: [null, [Validators.pattern(`^[,.&0-9${allowedCharacters}]+$`)]],
            firstName: [null, [Validators.required, Validators.pattern(`^[${allowedCharacters}]+$`)]],
            lastName: [null, [Validators.required, Validators.pattern(`^[${allowedCharacters}]+$`)]],
            street: [null, [Validators.required, Validators.pattern(`^[${allowedCharacters}]+$`)]],
            streetNumber: [null, [Validators.required, Validators.pattern('^[0-9a-zA-Z]{1,4}$')]],
            addressSupplement: [null, [Validators.pattern(`^[${allowedCharacters},.0-9]*$`)]],
            zipCode: [null, [Validators.required, Validators.pattern('^[0-9]{4}$')]],
            city: [null, [Validators.required, Validators.pattern(`^[${allowedCharacters}]*$`)]],
            country: [this.default],
            email: [null, [Validators.required, Validators.pattern('^[^@]+@[^.]+\.[^@]+$')]],
        }, { updateOn: 'change' });
    }
    /**
     * for update address ,insert old data in each input.
     * @return {?}
     */
    insertAddressFormData() {
        if (this.address) {
            this.address.subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                if (data) {
                    this.addressForm.patchValue({
                        company: data.company,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        street: data.street,
                        streetNumber: data.streetNumber,
                        addressSupplement: data.addressSupplement,
                        zipCode: data.zipCode,
                        city: data.city,
                        country: data.country,
                        email: data.email,
                    });
                }
            }));
        }
    }
    /**
     * @return {?}
     */
    get company() {
        return this.addressForm.get('company');
    }
    /**
     * @return {?}
     */
    get firstName() {
        return this.addressForm.get('firstName');
    }
    /**
     * @return {?}
     */
    get lastName() {
        return this.addressForm.get('lastName');
    }
    /**
     * @return {?}
     */
    get street() {
        return this.addressForm.get('street');
    }
    /**
     * @return {?}
     */
    get streetNumber() {
        return this.addressForm.get('streetNumber');
    }
    /**
     * @return {?}
     */
    get addressSupplement() {
        return this.addressForm.get('addressSupplement');
    }
    /**
     * @return {?}
     */
    get zipCode() {
        return this.addressForm.get('zipCode');
    }
    /**
     * @return {?}
     */
    get city() {
        return this.addressForm.get('city');
    }
    /**
     * @return {?}
     */
    get email() {
        return this.addressForm.get('email');
    }
    /**
     * not allow input contain only white space as input.
     * @param {?} control
     * @return {?}
     */
    noWhitespaceValidator(control) {
        /** @type {?} */
        const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
        /** @type {?} */
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    /**
     * @return {?}
     */
    emitInputsValid() {
        this.inputsValid.emit(this.addressForm.valid);
    }
    /**
     * @return {?}
     */
    emitInputsData() {
        this.inputsData.emit(this.addressForm.value);
    }
    /**
     * @return {?}
     */
    emitAlertMsg() {
        this.alertMsg.emit(document.getElementsByName('requiredField').length === 0 ? false : true);
    }
    /**
     * @return {?}
     */
    onChanges() {
        this.addressForm.valueChanges.forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            this.emitInputsValid();
            this.emitInputsData();
            this.emitAlertMsg();
        }));
    }
    /**
     * @return {?}
     */
    getCurrentLanguage() {
        return localStorage.getItem('currentLanguage') ? localStorage.getItem('currentLanguage') : `de-ch`;
    }
    /**
     * @param {?} field
     * @param {?} fieldName
     * @return {?}
     */
    checkForFieldError(field, fieldName) {
        console.log(field);
        if (field && fieldName) {
            if (field.touched) {
                this.fieldErrorFlags[fieldName] = field.invalid;
            }
            else {
                this.fieldErrorFlags[fieldName] = false;
            }
        }
    }
}
AddressDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-address-fe-details',
                template: "<div class=\"address-details-container\">\n  <p>{{title}}</p>\n  <form [formGroup]=\"addressForm\" (blur)=\"onChanges()\">\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_company\" | injectedText | async }}\n        <span class=\"optional\">{{ \"modeso_address_address-details_optional\" | injectedText | async }}</span>\n      </label>\n      <div class=\"input-wrapper\">\n        <input id=\"company\" class=\"form-control\" type=\"text\" minlength=\"1\" maxlength=\"40\" formControlName=\"company\" [ngClass]=\"{'invalid-input': fieldErrorFlags['company']}\"\n          value=\"{{(address|async)?.company}}\" (focusout)=\"checkForFieldError(company, 'company'); emitAlertMsg()\">\n      </div>\n      <span class=\"required\" *ngIf=\"fieldErrorFlags['company']\">\n        {{ \"modeso_address_address-details_company-required\" | injectedText | async }}\n      </span>\n    </div>\n    <!-- First Name -->\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_first-name\" | injectedText | async }}</label>\n      <div class=\"input-wrapper\">\n        <input id=\"firstName\" class=\"form-control\" minlength=\"1\" maxlength=\"40\" [ngClass]=\"{'invalid-input': fieldErrorFlags['firstName']}\" type=\"text\" formControlName=\"firstName\"\n          value=\"{{(address|async)?.firstName}}\" required (focusout)=\"checkForFieldError(firstName, 'firstName'); emitAlertMsg()\">\n      </div>\n      <span class=\"required\" *ngIf=\"fieldErrorFlags['firstName']\">\n        {{ \"modeso_address_address-details_first-name-required\" | injectedText | async }}\n      </span>\n    </div>\n    <!-- Last Name -->\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_last-name\" | injectedText | async }}</label>\n      <div class=\"input-wrapper\">\n        <input id=\"lastName\" class=\"form-control\" minlength=\"1\" maxlength=\"80\" [ngClass]=\"{'invalid-input': fieldErrorFlags['lastName']}\" type=\"text\" formControlName=\"lastName\"\n          value=\"{{(address|async)?.lastName}}\" required (focusout)=\"checkForFieldError(lastName, 'lastName'); emitAlertMsg()\">\n      </div>\n      <span class=\"required\" *ngIf=\"fieldErrorFlags['lastName']\">\n        {{ \"modeso_address_address-details_last-name-required\" | injectedText | async }}\n      </span>\n    </div>\n    <!-- Street -->\n    <div class=\"form-row\">\n      <div class=\"form-group col-lg-10\">\n        <label>{{ \"modeso_address_address-details_street\" | injectedText | async }}</label>\n        <input id=\"street\" class=\"form-control\" minlength=\"1\" maxlength=\"250\" [ngClass]=\"{'invalid-input': fieldErrorFlags['street']}\" type=\"text\" formControlName=\"street\" value=\"{{(address|async)?.street}}\"\n         (focusout)=\"checkForFieldError(street, 'street'); emitAlertMsg()\">\n        <span class=\"required\" *ngIf=\"fieldErrorFlags['street']\">\n          {{ \"modeso_address_address-details_street-required\" | injectedText | async }}\n        </span>\n      </div>\n      <!-- Street Number-->\n      <div class=\"form-group col-lg-2\">\n        <label>{{ \"modeso_address_address-details_street-number\" | injectedText | async }}</label>\n        <input id=\"streetNumber\" class=\"form-control\" maxlength=\"4\" [ngClass]=\"{'invalid-input': fieldErrorFlags['streetNumber']}\" type=\"text\" formControlName=\"streetNumber\"\n          value=\"{{(address|async)?.streetNumber}}\" (focusout)=\"checkForFieldError(streetNumber, 'streetNumber'); emitAlertMsg()\">\n        <span class=\"required\" *ngIf=\"fieldErrorFlags['streetNumber']\">\n          {{ \"modeso_address_address-details_street-number-required\" | injectedText | async }}\n        </span>\n      </div>\n    </div>\n    <!-- Address Supplement -->\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_address-supplement\" | injectedText | async }}\n        <span class=\"optional\">{{ \"modeso_address_address-details_optional\" | injectedText | async }}</span>\n      </label>\n      <div class=\"input-wrapper\">\n        <input id=\"addressSupplement\" minlength=\"1\" maxlength=\"250\" class=\"form-control\" type=\"text\" formControlName=\"addressSupplement\" [ngClass]=\"{'invalid-input': fieldErrorFlags['addressSupplement']}\"\n          value=\"{{(address|async)?.addressSupplement}}\"  (focusout)=\"checkForFieldError(addressSupplement, 'addressSupplement'); emitAlertMsg()\">\n      </div>\n      <span class=\"required\" *ngIf=\"fieldErrorFlags['addressSupplement']\">\n        {{ \"modeso_address_address-details_address-supplement-required\" | injectedText | async }}\n      </span>\n    </div>\n    <!-- Zip Code -->\n    <div class=\"form-row\">\n      <div class=\"form-group col-lg-2\">\n        <label>{{ \"modeso_address_address-details_zip-code\" | injectedText | async }}</label>\n        <input id=\"zipCode\" class=\"form-control\" [ngClass]=\"{'invalid-input': fieldErrorFlags['zipCode']}\" type=\"text\" formControlName=\"zipCode\" minlength=\"4\" maxlength=\"4\"\n          value=\"{{(address|async)?.zipCode}}\" (focusout)=\"checkForFieldError(zipCode, 'zipCode'); emitAlertMsg()\">\n        <span class=\"required\" *ngIf=\"fieldErrorFlags['zipCode']\">\n          {{ \"modeso_address_address-details_zip-code-required\" | injectedText | async }}\n        </span>\n      </div>\n      <!-- city -->\n      <div class=\"form-group col-lg-10\">\n        <label>{{ \"modeso_address_address-details_city\" | injectedText | async }}</label>\n        <input id=\"city\" class=\"form-control\" minlength=\"2\" maxlength=\"40\" [ngClass]=\"{'invalid-input': fieldErrorFlags['city']}\" type=\"text\" formControlName=\"city\" value=\"{{(address|async)?.city}}\"\n         (focusout)=\"checkForFieldError(city, 'city'); emitAlertMsg()\">\n        <span class=\"required\" *ngIf=\"fieldErrorFlags['city']\">\n          {{ \"modeso_address_address-details_city-required\" | injectedText | async }}\n        </span>\n      </div>\n    </div>\n    <!-- Country -->\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_country\" | injectedText | async }}</label>\n      <div class=\"input-wrapper\">\n        <select class=\"classic col-12\" id=\"country\" formControlName=\"country\">\n          <option *ngFor=\"let country of countries\" [value]=\"country.code\">{{ country.name[getCurrentLanguage()] }}</option>\n        </select>\n      </div>\n    </div>\n    <!-- email -->\n    <div class=\"form-group\">\n      <label>{{ \"modeso_address_address-details_email\" | injectedText | async }}</label>\n      <div class=\"input-wrapper\">\n        <input id=\"email\" class=\"form-control\" type=\"email\" minlength=\"5\" maxlength=\"80\" [ngClass]=\"{'invalid-input': fieldErrorFlags['email']}\" formControlName=\"email\" value=\"{{(address|async)?.email}}\"\n          required (focusout)=\"checkForFieldError(email, 'email'); emitAlertMsg()\">\n      </div>\n      <span class=\"required\" *ngIf=\"fieldErrorFlags['email']\">\n        {{ \"modeso_address_address-details_email-required\" | injectedText | async }}\n      </span>\n    </div>\n  </form>\n</div>\n",
                styles: [".address-details-container{font-weight:400;font-size:16px}.address-details-container label{font-weight:400;display:block}.address-details-container p{font-weight:700;border-bottom:2px solid #ddd;margin-bottom:30px;padding:9px 0}.address-details-container .required-icon{margin-top:35px}.address-details-container .error-msg{display:flex;align-items:center}.address-details-container .optional{color:#b3aeb6;margin-left:5px}.address-details-container .form-control{margin-bottom:10px;height:38px;border:1px solid #919191;margin-right:10px;border-radius:0}.address-details-container .input-display{display:flex}.address-details-container .streetNo-display{display:flex;float:right}.address-details-container .required{color:red}.address-details-container .ng-untouched.ng-invalid{border-color:#919191}.address-details-container .invalid-input{border-color:red}.address-details-container select{background-color:#fff;border-radius:initial;border-color:#919191;padding:10px;margin-bottom:10px;-webkit-appearance:none}.address-details-container select.classic{background-image:linear-gradient(45deg,transparent 50%,#fff 50%),linear-gradient(135deg,#fff 50%,transparent 50%),linear-gradient(to right,#989898,#989898);background-position:calc(100% - 20px) calc(1em + 2px),calc(100% - 15px) calc(1em + 2px),100% 0;background-size:5px 5px,5px 5px,2.5em 3em;background-repeat:no-repeat}"]
            }] }
];
/** @nocollapse */
AddressDetailsComponent.ctorParameters = () => [
    { type: FormBuilder }
];
AddressDetailsComponent.propDecorators = {
    title: [{ type: Input }],
    src: [{ type: Input }],
    isBillingAddress: [{ type: Input }],
    address: [{ type: Input }],
    inputsValid: [{ type: Output }],
    inputsData: [{ type: Output }],
    alertMsg: [{ type: Output }]
};
if (false) {
    /**
     * src:x image for wrong validation.
     * @type {?}
     */
    AddressDetailsComponent.prototype.title;
    /** @type {?} */
    AddressDetailsComponent.prototype.src;
    /** @type {?} */
    AddressDetailsComponent.prototype.isBillingAddress;
    /** @type {?} */
    AddressDetailsComponent.prototype.address;
    /** @type {?} */
    AddressDetailsComponent.prototype.inputsValid;
    /** @type {?} */
    AddressDetailsComponent.prototype.inputsData;
    /** @type {?} */
    AddressDetailsComponent.prototype.alertMsg;
    /** @type {?} */
    AddressDetailsComponent.prototype.address$;
    /** @type {?} */
    AddressDetailsComponent.prototype.addressForm;
    /** @type {?} */
    AddressDetailsComponent.prototype.fieldErrorFlags;
    /**
     * countries  dropdown list.
     * default:choose default country is switherland.
     * @type {?}
     */
    AddressDetailsComponent.prototype.countries;
    /** @type {?} */
    AddressDetailsComponent.prototype.default;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/addressLocalStorageService.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddressLocalStorageService {
    constructor() { }
    /**
     * return local storage.
     * @return {?}
     */
    getLocalStorage() {
        return localStorage;
    }
    /**
     * return session storage.
     * @return {?}
     */
    getSessionStorage() {
        return sessionStorage;
    }
    /**
     * set when Billing Address is the same as the Delivery Address for an order.
     * @param {?} equal
     * @return {?}
     */
    setBillingAddressSameAsDeliveryAddress(equal) {
        this.getSessionStorage().setItem(AddressLocalStorageService.billingSameAsDelivery, JSON.stringify(equal));
    }
    /**
     * check if Billing Address is the same as the Delivery Address for an order.
     * @return {?}
     */
    isBillingAddressSameAsDeliveryAddress() {
        return JSON.parse(this.getSessionStorage().getItem(AddressLocalStorageService.billingSameAsDelivery));
    }
    /**
     * remove the check if Billing Address is the same as the Delivery Address for an order.
     * @return {?}
     */
    removeBillingAddressSameAsDeliveryAddressFlag() {
        this.getSessionStorage().removeItem(AddressLocalStorageService.billingSameAsDelivery);
    }
}
AddressLocalStorageService.billingAddressKey = 'BillingAddressId';
AddressLocalStorageService.deliveryAddressKey = 'DeliveryAddressId';
AddressLocalStorageService.billingSameAsDelivery = 'BillingSameAsDelivery';
AddressLocalStorageService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
AddressLocalStorageService.ctorParameters = () => [];
/** @nocollapse */ AddressLocalStorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AddressLocalStorageService_Factory() { return new AddressLocalStorageService(); }, token: AddressLocalStorageService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AddressLocalStorageService.billingAddressKey;
    /**
     * @type {?}
     * @private
     */
    AddressLocalStorageService.deliveryAddressKey;
    /**
     * @type {?}
     * @private
     */
    AddressLocalStorageService.billingSameAsDelivery;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/address.action.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * We can change the addresss state using the actions.
 * This is action of post delivery addresss.
 * @type {?}
 */
const postDeliveryAddress = createAction('[Address] postDeliveryAddress', props());
/**
 * This is action of post delivery address when it return successfully.
 * @type {?}
 */
const onDeliveryAddressPostedSuccessfully = createAction('[Address] delivery address posted successfully', props());
/**
 * This is action of post delivery address when it failed.
 * @type {?}
 */
const onDeliveryAddressPostingFailed = createAction('[Address]  delivery address loading failed', props());
/**
 * We can change the addresss state using the actions.
 * This is action of post billing addresss.
 * @type {?}
 */
const postBillingAddress = createAction('[Address] postBillingAddress', props());
/**
 * This is action of post billing address when it return successfully.
 * @type {?}
 */
const onBillingAddressPostedSuccessfully = createAction('[Address] billing address posted successfully', props());
/**
 * This is action of posy billing address when it failed.
 * @type {?}
 */
const onBillingAddressPostingFailed = createAction('[Address]  billing address posting failed', props());
/**
 * We can change the Address state using the actions.
 * This is action of get delivery address by id.
 * @type {?}
 */
const getDeliveryAddressById = createAction('[Address] getDeliveryAddressById', props());
/**
 * This is action of get delivery address by id when it return successfully.
 * @type {?}
 */
const onAddressDeliveryByIdLoadedSuccessfully = createAction('[Address]  addressById loaded successfully', props());
/**
 * This is action of get delivery address by id when it failed.
 * @type {?}
 */
const onAddressDeliveryByIdLoadingFailed = createAction('[Address]  addressById loading failed', props());
/**
 * We can change the Address state using the actions.
 * This is action of get billing address by id.
 * @type {?}
 */
const getBillingAddressById = createAction('[Address] getBillingAddressById', props());
/**
 * This is action of get billing address by id when it return successfully.
 * @type {?}
 */
const onAddressBillingByIdLoadedSuccessfully = createAction('[Address]  addressById loaded successfully', props());
/**
 * This is action of get billing address by id id when it failed.
 * @type {?}
 */
const onAddressBillingByIdLoadingFailed = createAction('[Address]  addressById loading failed', props());
/**
 * We can change the addresss state using the actions.
 * This is action of put delivery addresss.
 * @type {?}
 */
const putDeliveryAddress = createAction('[Address] putDeliveryAddress', props());
/**
 * This is action of put delivery addresss when it return successfully.
 * @type {?}
 */
const onPutDeliveryAddressSuccessfully = createAction('[Address] delivery address edited successfully', props());
/**
 * This is action of put delivery addresss when it failed.
 * @type {?}
 */
const onPutDeliveryAddressFailed = createAction('[Address]  delivery address edit failed', props());
/**
 * We can change the addresss state using the actions.
 * This is action of put billing addresss.
 * @type {?}
 */
const putBillingAddress = createAction('[Address] putBillingAddress', props());
/**
 * This is action of put billing addresss when it return successfully.
 * @type {?}
 */
const onPutBillingAddressSuccessfully = createAction('[Address] billing address edited successfully', props());
/**
 * This is action of put billing addresss when it failed.
 * @type {?}
 */
const onPutBillingAddressFailed = createAction('[Address]  billing address edited failed', props());
/**
 * We can change the Address state using the actions.
 * This is action of get billing address by id.
 * @type {?}
 */
const deleteBillingAddress = createAction('[Address] deleteBillingAddress', props());
/**
 * This is action of get billing address by id when it return successfully.
 * @type {?}
 */
const onDeleteAddressBillingSuccessfully = createAction('[Address] delete address successfully', props());
/**
 * This is action of get billing address by id id when it failed.
 * @type {?}
 */
const onDeleteAddressBillingFailed = createAction('[Address] delete address failed', props());
/**
 * This is action of is billing address.
 * @type {?}
 */
const onIsBillingAddressMarked = createAction('[Address] is Billing address marked', props());
/**
 * Dispatch to pass payload, you can create parametrizied Action in this way.
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/**
 * action delivery with address id.
 * @record
 */
function ActionDeliveryWithAddressId() { }
if (false) {
    /** @type {?} */
    ActionDeliveryWithAddressId.prototype._id;
}
/**
 * action billing with address id.
 * @record
 */
function ActionBillingWithAddressId() { }
if (false) {
    /** @type {?} */
    ActionBillingWithAddressId.prototype._id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/address.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'modesoAddressMicroservice';
// State Declarations - START
/** @type {?} */
const adapter = createEntityAdapter({
    selectId: selectAddressId,
    sortComparer: sortById,
});
/**
 * @param {?} a
 * @return {?}
 */
function selectAddressId(a) {
    return a._id;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sortById(a, b) {
    return a._id.localeCompare(b._id);
}
/**
 * @record
 */
function FeatureState() { }
if (false) {
    /** @type {?} */
    FeatureState.prototype.isMarked;
}
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoAddressMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoAddressMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureAddress = createSelector(selectFeature, (ɵ0));
const { selectAll, selectEntities, selectIds, selectTotal, } = adapter.getSelectors();
/** @type {?} */
const selectAddressEntities = createSelector(selectFeatureAddress, selectEntities);
const ɵ1 = /**
 * @param {?} entities
 * @return {?}
 */
(entities) => entities;
/** @type {?} */
const selectAllAddresses = createSelector(selectFeatureAddress, (ɵ1));
/** @type {?} */
const selectAddressAllEntities = createSelector(selectFeatureAddress, selectAll);
const ɵ2 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectEntitiesByID = createSelector(selectAddressEntities, (ɵ2));
const ɵ3 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities.filter((/**
     * @param {?} address
     * @return {?}
     */
    address => address.collection === props.filter));
};
/** @type {?} */
const selectEntitiesByFilter = createSelector(selectAddressAllEntities, (ɵ3));
const ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.isMarked;
/** @type {?} */
const selectIsBillingAddress = createSelector(selectFeature, (ɵ4));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = adapter.getInitialState({
    isMarked: true,
});
const ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ6 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, state);
}, ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ8 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ9 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, state);
}, ɵ10 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ11 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ12 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, state);
}, ɵ13 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ14 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ15 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, state);
}, ɵ16 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ17 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ18 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.updateOne({ id: action.payload._id, changes: action.payload }, state);
}, ɵ19 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ20 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ21 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.updateOne({ id: action.payload._id, changes: action.payload }, state);
}, ɵ22 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ23 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ24 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.removeOne(action.payload.id, state);
}, ɵ25 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ26 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { isMarked: action.payload }));
/** @type {?} */
const addressReducer = createReducer(initialState, on(postDeliveryAddress, (ɵ5)), on(onDeliveryAddressPostedSuccessfully, (ɵ6)), on(onDeliveryAddressPostingFailed, (ɵ7)), on(postBillingAddress, (ɵ8)), on(onBillingAddressPostedSuccessfully, (ɵ9)), on(onBillingAddressPostingFailed, (ɵ10)), on(getDeliveryAddressById, (ɵ11)), on(onAddressDeliveryByIdLoadedSuccessfully, (ɵ12)), on(onAddressDeliveryByIdLoadingFailed, (ɵ13)), on(getBillingAddressById, (ɵ14)), on(onAddressBillingByIdLoadedSuccessfully, (ɵ15)), on(onAddressBillingByIdLoadingFailed, (ɵ16)), on(putDeliveryAddress, (ɵ17)), on(onPutDeliveryAddressSuccessfully, (ɵ18)), on(onPutDeliveryAddressFailed, (ɵ19)), on(putBillingAddress, (ɵ20)), on(onPutBillingAddressSuccessfully, (ɵ21)), on(onPutBillingAddressFailed, (ɵ22)), on(deleteBillingAddress, (ɵ23)), on(onDeleteAddressBillingSuccessfully, (ɵ24)), on(onDeleteAddressBillingFailed, (ɵ25)), on(onIsBillingAddressMarked, (ɵ26)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return addressReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/addressType.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const AddressType = {
    DELIVERYADDRESS: "DELIVERYADDRESS",
    BILLINGADDRESS: "BILLINGADDRESS",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-address/compact-address.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:lidl-lib-address-fe:CompactAddressComponent');
class CompactAddressComponent {
    /**
     *
     * @param {?} router
     * @param {?} addressLocalStorageService
     * @param {?} store
     * @param {?} orderService
     */
    constructor(router, addressLocalStorageService, store, orderService) {
        this.router = router;
        this.addressLocalStorageService = addressLocalStorageService;
        this.store = store;
        this.orderService = orderService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.router.url.includes('order')) {
                /** @type {?} */
                const urlSegments = this.router.url.split('/');
                /** @type {?} */
                const orderId = urlSegments[urlSegments.indexOf('order') + 1]
                // this.store.dispatch(orderActions.getById({ orderId }));
                // this.orderStore.pipe(select(orderReducer.selectOrderByID, { id: orderId }))
                ;
                // this.store.dispatch(orderActions.getById({ orderId }));
                // this.orderStore.pipe(select(orderReducer.selectOrderByID, { id: orderId }))
                this.orderService.getById(orderId)
                    .subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                (response) => {
                    this.isSetDeliveryAddressId = true;
                    if (this.addressLocalStorageService.isBillingAddressSameAsDeliveryAddress() === false) {
                        this.deliveryAddress$ = of(response.order.address[0]);
                        this.billingAddress$ = of(response.order.address[1]);
                        this.isSetBillingAddressId = true;
                        this.addressLocalStorageService.removeBillingAddressSameAsDeliveryAddressFlag();
                    }
                    else {
                        this.billingAddress$ = this.deliveryAddress$ = of(response.order.address[0]);
                    }
                }));
            }
            else {
                this.getDeliveryAddressById();
                this.getBillingAddressById();
            }
        });
    }
    /**
     * @return {?}
     */
    getDeliveryAddressById() {
        this.store.pipe(select(selectEntitiesByID, { id: AddressType.DELIVERYADDRESS })).subscribe((/**
         * @param {?} address
         * @return {?}
         */
        (address) => {
            this.isSetDeliveryAddressId = !!address;
            // if user tries to access payment page and address is not in store redirect back to address page to fill it
            if (!this.isSetDeliveryAddressId) {
                this.router.navigateByUrl(`${localStorage.getItem('currentLanguage')}/address`);
            }
        }));
        this.deliveryAddress$ = this.store.pipe(select(selectEntitiesByID, { id: AddressType.DELIVERYADDRESS }));
    }
    /**
     * @return {?}
     */
    getBillingAddressById() {
        if (this.addressLocalStorageService.isBillingAddressSameAsDeliveryAddress() === false) {
            this.store.pipe(select(selectEntitiesByID, { id: AddressType.BILLINGADDRESS })).subscribe((/**
             * @param {?} address
             * @return {?}
             */
            (address) => {
                this.isSetBillingAddressId = !!address;
            }));
            this.billingAddress$ = this.store.pipe(select(selectEntitiesByID, { id: AddressType.BILLINGADDRESS }));
        }
        else {
            this.isSetBillingAddressId = false;
        }
    }
    /**
     * Check if there is a currentLanguage in localstorage will return it else will return 'de-ch' as a default language.
     * @private
     * @return {?}
     */
    getLanguageFromLocalStorage() {
        return localStorage.getItem('currentLanguage') ? localStorage.getItem('currentLanguage') : `de-ch`;
    }
}
CompactAddressComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-address',
                template: "<div class=\"compact-address-container\">\n  <div class=\"title\">\n    <div class=\"row\">\n      <!-- title -->\n      <div class=\"col-lg-6\">\n        <h5>{{ \"modeso_address_compact-address_address\" | injectedText | async }}</h5>\n      </div>\n      <!-- button to change address -->\n      <div class=\"col-lg-6\" *ngIf=\"ChangeAddress\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <div *ngIf=\"!ChangeAddress\">\n      <hr>\n    </div>\n  </div>\n  <!-- address details -->\n  <modeso-compact-address-details id=\"compactDeliveryAddress\" *ngIf=\"isSetDeliveryAddressId\"\n    [address]=\"deliveryAddress$\" [addressType]=\"'modeso_address_compact-address_delivery-address'\"\n    [isBillingAddress]=\"isSetBillingAddressId\">\n  </modeso-compact-address-details>\n  <modeso-compact-address-details id=\"compactBillingAddress\" *ngIf=\"isSetBillingAddressId\" [address]=\"billingAddress$\"\n    [addressType]=\"'modeso_address_compact-address_billing-address'\" [isBillingAddress]=\"isSetBillingAddressId\">\n  </modeso-compact-address-details>\n  <div *ngIf=\"!isSetBillingAddressId\" class=\"address-type\">\n    <span>{{ \"modeso_address_address_delivery-billing\" | injectedText | async }}\n      {{ \"modeso_address_address_same-address\" | injectedText | async }}</span>\n  </div>\n</div>\n",
                styles: [".compact-address-container{padding-bottom:30px}.compact-address-container h5{font-size:16px;font-weight:700;line-height:20px;margin-bottom:0;margin-top:0}.compact-address-container hr{border-top:.5px solid #d4d1d4;margin-top:10px;margin-bottom:10px}.compact-address-container .title{font-weight:700;padding-bottom:20px}.compact-address-container .title span{border-top:1px solid #bdbbbd}.compact-address-container .address-details{padding-bottom:20px}.compact-address-container .name{font-weight:700}.compact-address-container .address-type{background-color:#eaeaea;padding:10px}"]
            }] }
];
/** @nocollapse */
CompactAddressComponent.ctorParameters = () => [
    { type: Router },
    { type: AddressLocalStorageService },
    { type: Store },
    { type: OrderService }
];
CompactAddressComponent.propDecorators = {
    ChangeAddress: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactAddressComponent.prototype.ChangeAddress;
    /** @type {?} */
    CompactAddressComponent.prototype.deliveryAddress$;
    /** @type {?} */
    CompactAddressComponent.prototype.billingAddress$;
    /** @type {?} */
    CompactAddressComponent.prototype.isSetBillingAddressId;
    /** @type {?} */
    CompactAddressComponent.prototype.isSetDeliveryAddressId;
    /**
     * @type {?}
     * @private
     */
    CompactAddressComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    CompactAddressComponent.prototype.addressLocalStorageService;
    /**
     * @type {?}
     * @private
     */
    CompactAddressComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CompactAddressComponent.prototype.orderService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/address.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Address Model.
 */
class AddressModel {
    constructor() { }
}
if (false) {
    /** @type {?} */
    AddressModel.prototype.zipCode;
    /** @type {?} */
    AddressModel.prototype.city;
    /** @type {?} */
    AddressModel.prototype.country;
    /** @type {?} */
    AddressModel.prototype.countryName;
    /** @type {?} */
    AddressModel.prototype.firstName;
    /** @type {?} */
    AddressModel.prototype.lastName;
    /** @type {?} */
    AddressModel.prototype.email;
    /** @type {?} */
    AddressModel.prototype.street;
    /** @type {?} */
    AddressModel.prototype.streetNumber;
    /** @type {?} */
    AddressModel.prototype.company;
    /** @type {?} */
    AddressModel.prototype.addressSupplement;
    /** @type {?} */
    AddressModel.prototype.userId;
    /** @type {?} */
    AddressModel.prototype._id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address/address.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddressComponent {
    /**
     *
     * @param {?} store
     * @param {?} addressLocalStorageService
     */
    constructor(store, addressLocalStorageService) {
        this.store = store;
        this.addressLocalStorageService = addressLocalStorageService;
        this.subscribers = [];
        /**
         * inputData: delivery data model.
         * inputBillingData:billing data model
         */
        this.address = new AddressModel();
        this.inputData = new AddressModel();
        this.inputBillingData = new AddressModel();
        /**
         * inputAccepted: boolean variable for delivery address validation.
         * inputAcceptedBilling: boolean variable for billing address validation.
         * marked:boolean variable for checkbox.
         * alertMsg:boolean variable for show alertMsg.
         */
        this.inputAccepted = false;
        this.inputAcceptedBilling = false;
        this.marked = true;
        this.alertMsg = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.dispatchDeliveryAddress();
        if (!this.addressLocalStorageService.isBillingAddressSameAsDeliveryAddress()) {
            this.store.pipe(select(selectAddressAllEntities)).pipe(take(1)).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => {
                if (data && data.length > 1) {
                    this.dispatchBillingAddress();
                }
            }));
        }
    }
    /**
     * dispatch delivery address.
     * get delivery address by id from store.
     * @return {?}
     */
    dispatchDeliveryAddress() {
        this.deliveryAddress$ = this.store.pipe(select(selectEntitiesByID, { id: AddressType.DELIVERYADDRESS }));
        this.store.dispatch(getDeliveryAddressById({ _id: AddressType.DELIVERYADDRESS }));
    }
    /**
     * dispatch billing address.
     * get billing address by id from store.
     * @return {?}
     */
    dispatchBillingAddress() {
        this.marked = false;
        this.billingAddress$ = this.store.pipe(select(selectEntitiesByID, { id: AddressType.BILLINGADDRESS }));
        this.store.dispatch(getBillingAddressById({ _id: AddressType.BILLINGADDRESS }));
    }
    /**
     * set delivery data.
     * @param {?} inputData
     * @return {?}
     */
    setDeliveryData(inputData) {
        this.inputData = inputData;
    }
    /**
     * set billing data.
     * @param {?} inputBillingData
     * @return {?}
     */
    setBillingData(inputBillingData) {
        this.inputBillingData = inputBillingData;
    }
    /**
     * set validation of delivery address.
     * @param {?} inputAccepted
     * @return {?}
     */
    setDeliveryValidation(inputAccepted) {
        this.inputAccepted = inputAccepted;
    }
    /**
     * set validation of billing address.
     * @param {?} inputAcceptedBilling
     * @return {?}
     */
    setBillingValidation(inputAcceptedBilling) {
        this.inputAcceptedBilling = inputAcceptedBilling;
    }
    /**
     * set there is input in address or not.
     * @param {?} alertMsg
     * @return {?}
     */
    setAlertMsg(alertMsg) {
        this.alertMsg = alertMsg;
    }
    /**
     * check box status.
     * @param {?} event
     * @return {?}
     */
    showbillingAddress(event) {
        this.marked = event.target.checked;
        this.store.dispatch(onIsBillingAddressMarked({ payload: this.marked }));
    }
    /**
     * if checkbox is marked , no billing address so call submitDeliveryAddress function .
     * if there is billing id so call deleteBillingAddressId function.
     * if checkbox in unmarked, call submitDeliveryAddress and this.submitBillingAddress functions.
     * @return {?}
     */
    submit() {
        if (this.marked === true) {
            this.submitDeliveryAddress();
        }
        else {
            this.submitDeliveryAddress();
            this.submitBillingAddress();
        }
        this.addressLocalStorageService.setBillingAddressSameAsDeliveryAddress(this.marked);
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.gtagEnterAddress();
        }), 100);
    }
    /**
     * submit delivery address function.
     * save delivery address in store.
     * @return {?}
     */
    submitDeliveryAddress() {
        this.inputData._id = AddressType.DELIVERYADDRESS;
        this.store.pipe(select(selectEntitiesByID, { id: AddressType.DELIVERYADDRESS })).pipe(take(1)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            if (data) {
                this.store.dispatch(onPutDeliveryAddressSuccessfully({ payload: this.inputData }));
            }
            else {
                this.store.dispatch(onDeliveryAddressPostedSuccessfully({ payload: this.inputData }));
            }
        }));
    }
    /**
     * submit billing address function.
     * save billing address in store.
     * @return {?}
     */
    submitBillingAddress() {
        this.inputBillingData._id = AddressType.BILLINGADDRESS;
        this.store.pipe(select(selectEntitiesByID, { id: AddressType.BILLINGADDRESS })).pipe(take(1)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            if (data) {
                this.store.dispatch(onPutBillingAddressSuccessfully({ payload: this.inputBillingData }));
            }
            else {
                this.store.dispatch(onBillingAddressPostedSuccessfully({ payload: this.inputBillingData }));
            }
        }));
    }
    /**
     * check condition of save button if it is disabled or not.
     * @return {?}
     */
    buttonStatus() {
        return !((this.marked && this.inputAccepted) || (!this.marked && this.inputAccepted && this.inputAcceptedBilling));
    }
    /**
     * alert msg appear when validation are not correct.
     * @return {?}
     */
    alertMsgStatus() {
        return this.alertMsg === false ? false : (!((this.marked && this.inputAccepted) ||
            (!this.marked && this.inputAccepted && this.inputAcceptedBilling)));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        (this.subscribers || []).forEach((/**
         * @param {?} subscribtion
         * @return {?}
         */
        subscribtion => {
            subscribtion.unsubscribe();
        }));
    }
    /**
     * @return {?}
     */
    gtagEnterAddress() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': { 'step': 1 },
                }
            }
        });
    }
}
AddressComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-address-fe',
                template: "<div class=\"address-details-container\">\n  <div class=\"row\">\n    <div class=\"col-lg-7\">\n      <!-- delivery address -->\n      <lidl-lib-address-fe-details id=\"deliveryAddress\" src=\"assets/lidl-lib-address-fe/times-light/times-light.svg\"\n        [title]=\"('modeso_address_compact-address_delivery-address' | injectedText | async)\" (inputsValid)='setDeliveryValidation($event)' (inputsData)='setDeliveryData($event)'\n        (alertMsg)='setAlertMsg($event)' [address]=\"deliveryAddress$\" [isBillingAddress]=\"false\">\n      </lidl-lib-address-fe-details>\n      <!-- checkbox -->\n      <label class=\"checkbox-container\">\n        <input id=\"setBillingaddress\" type=\"checkbox\" [(ngModel)]=\"marked\" (change)=\"showbillingAddress($event)\">\n        {{ \"modeso_address_address_delivery-billing\" | injectedText | async }}<span>{{ \"modeso_address_address_same-address\" | injectedText | async }}</span>\n      </label>\n      <!-- billing address -->\n      <lidl-lib-address-fe-details id=\"billingAddress\" src=\"assets/lidl-lib-address-fe/times-light/times-light.svg\"\n        [title]=\"('modeso_address_compact-address_billing-address' | injectedText | async)\" (inputsValid)='setBillingValidation($event)' (inputsData)='setBillingData($event)'\n        (alertMsg)='setAlertMsg($event)' *ngIf=\"!marked\" [address]=\"billingAddress$\" [isBillingAddress]=\"true\">\n\n\n      </lidl-lib-address-fe-details>\n    </div>\n    <div class=\"col-lg-5\">\n      <!-- cart details -->\n      <div class=\"order-details-container\">\n        <ng-content></ng-content>\n      </div>\n      <!-- validation message -->\n      <div id=\"alertMsg\" class=\"validation-msg\" *ngIf=\"alertMsgStatus()\">\n        <span>{{ \"modeso_address_address_required-msg\" | injectedText | async }}</span>\n      </div>\n\n    </div>\n  </div>\n</div>\n",
                styles: [".address-details-container{margin-top:50px}.save-button button{width:370px;height:52px;background-color:#0076bf;color:#fff;border:0;float:right}.save-button button:disabled{opacity:.5}.checkbox-container{font-weight:400;padding-top:20px;margin-bottom:35px}.checkbox-container span{font-weight:700}.validation-msg{background-color:#ef080c;padding:16px;color:#fff;text-align:center;margin-bottom:30px;font-size:16px}"]
            }] }
];
/** @nocollapse */
AddressComponent.ctorParameters = () => [
    { type: Store },
    { type: AddressLocalStorageService }
];
AddressComponent.propDecorators = {
    src: [{ type: Input }]
};
if (false) {
    /**
     * src for x image for validation.
     * @type {?}
     */
    AddressComponent.prototype.src;
    /** @type {?} */
    AddressComponent.prototype.subscribers;
    /**
     * inputData: delivery data model.
     * inputBillingData:billing data model
     * @type {?}
     */
    AddressComponent.prototype.address;
    /** @type {?} */
    AddressComponent.prototype.inputData;
    /** @type {?} */
    AddressComponent.prototype.inputBillingData;
    /**
     * inputAccepted: boolean variable for delivery address validation.
     * inputAcceptedBilling: boolean variable for billing address validation.
     * marked:boolean variable for checkbox.
     * alertMsg:boolean variable for show alertMsg.
     * @type {?}
     */
    AddressComponent.prototype.inputAccepted;
    /** @type {?} */
    AddressComponent.prototype.inputAcceptedBilling;
    /** @type {?} */
    AddressComponent.prototype.marked;
    /** @type {?} */
    AddressComponent.prototype.alertMsg;
    /** @type {?} */
    AddressComponent.prototype.deliveryAddress$;
    /** @type {?} */
    AddressComponent.prototype.billingAddress$;
    /**
     * @type {?}
     * @private
     */
    AddressComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    AddressComponent.prototype.addressLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/address.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AddressResponse() { }
if (false) {
    /** @type {?} */
    AddressResponse.prototype.address;
}
class AddressService {
    /**
     *
     * @param {?} http
     * @param {?} config
     * @param {?} addressLocalStorageService
     */
    constructor(http, config, addressLocalStorageService) {
        this.http = http;
        this.config = config;
        this.addressLocalStorageService = addressLocalStorageService;
        this.server = '';
        this.microserviceName = 'address';
        this.route = '/';
        this.server = config.apiGateway;
    }
}
AddressService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
AddressService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ModesoAddressConfigService,] }] },
    { type: AddressLocalStorageService }
];
/** @nocollapse */ AddressService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AddressService_Factory() { return new AddressService(ɵɵinject(HttpClient), ɵɵinject(ModesoAddressConfigService), ɵɵinject(AddressLocalStorageService)); }, token: AddressService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    AddressService.prototype.addressLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/address.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:lidl-lib-address-fe:AddressEffects');
class AddressEffects {
    /**
     *
     * @param {?} actions$
     * @param {?} service
     * @param {?} addressLocalStorageService
     */
    constructor(actions$, service, addressLocalStorageService) {
        this.actions$ = actions$;
        this.service = service;
        this.addressLocalStorageService = addressLocalStorageService;
        this.errorOnPostDeliveryAddress$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onDeliveryAddressPostingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        this.errorOnPostBillingAddress$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onBillingAddressPostingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        /**
         * Effect of load delivery address error.
         */
        this.errorOnLoadDeliveryAddressById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onAddressDeliveryByIdLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        /**
         * Effect of load billing address error.
         */
        this.errorOnLoadBillingAddressById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onAddressDeliveryByIdLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        /**
         * Effect of put delivery address error.
         */
        this.errorOnPutDeliveryAddress$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onPutDeliveryAddressFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        /**
         * Effect of put billing address error.
         */
        this.errorOnPutBillingAddress$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onPutBillingAddressFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
        /**
         * Effect of delete billing address error.
         */
        this.errorOnDeleteBillingAddress$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onDeleteAddressBillingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleAddresddErrors(action.payload))))), { dispatch: false });
    }
    /**
     * log address error and return error.
     * @param {?} error
     * @return {?}
     */
    handleAddresddErrors(error) {
        debug$1(error);
        return error;
    }
    /**
     * log data.
     * @param {?} data
     * @return {?}
     */
    log(data) {
        debug$1(data);
    }
}
AddressEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AddressEffects.ctorParameters = () => [
    { type: Actions },
    { type: AddressService },
    { type: AddressLocalStorageService }
];
if (false) {
    /** @type {?} */
    AddressEffects.prototype.errorOnPostDeliveryAddress$;
    /** @type {?} */
    AddressEffects.prototype.errorOnPostBillingAddress$;
    /**
     * Effect of load delivery address error.
     * @type {?}
     */
    AddressEffects.prototype.errorOnLoadDeliveryAddressById$;
    /**
     * Effect of load billing address error.
     * @type {?}
     */
    AddressEffects.prototype.errorOnLoadBillingAddressById$;
    /**
     * Effect of put delivery address error.
     * @type {?}
     */
    AddressEffects.prototype.errorOnPutDeliveryAddress$;
    /**
     * Effect of put billing address error.
     * @type {?}
     */
    AddressEffects.prototype.errorOnPutBillingAddress$;
    /**
     * Effect of delete billing address error.
     * @type {?}
     */
    AddressEffects.prototype.errorOnDeleteBillingAddress$;
    /**
     * @type {?}
     * @private
     */
    AddressEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    AddressEffects.prototype.service;
    /**
     * @type {?}
     * @private
     */
    AddressEffects.prototype.addressLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/address-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddressUtils {
    constructor() {
    }
    /**
     * @param {?} countryCode
     * @return {?}
     */
    static getCountryNameByCode(countryCode) {
        /** @type {?} */
        const selectedCountry = AddressUtils.countries.find((/**
         * @param {?} country
         * @return {?}
         */
        country => country.code === countryCode));
        if (selectedCountry) {
            return selectedCountry.name[this.getCurrentLanguage()];
        }
    }
    /**
     * @return {?}
     */
    static getCurrentLanguage() {
        return localStorage.getItem('currentLanguage') ? localStorage.getItem('currentLanguage') : `de-ch`;
    }
}
AddressUtils.countries = CountriesJson;
if (false) {
    /** @type {?} */
    AddressUtils.countries;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-address-details/compact-address-details.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CompactAddressDetailsComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.address.subscribe((/**
         * @param {?} addressData
         * @return {?}
         */
        addressData => {
            if (addressData) {
                addressData.countryName = AddressUtils.getCountryNameByCode(addressData.country);
            }
        }));
    }
}
CompactAddressDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-address-details',
                template: "<div class=\"compact-address-details-container\">\n  <div *ngIf=\"isBillingAddress\" class=\"bold address-type\">\n    <span id=\"addressType\">{{addressType | injectedText | async }}</span>\n  </div>\n  <div class=\"address-details\">\n    <div>\n      <span>{{(address|async)?.company}}</span>\n    </div>\n    <div class=\"bold\">\n      <span id=\"firstName\">{{(address|async)?.firstName}}</span>\n      <span id=\"lastName\"> {{(address|async)?.lastName}}</span>\n    </div>\n    <div>\n      <span id=\"street\">{{(address|async)?.street}}</span>\n      <span id=\"streetNumber\"> {{(address|async)?.streetNumber}}</span>\n    </div>\n    <div>\n      <span id=\"zipCode\">{{(address|async)?.zipCode}}</span>\n      <span id=\"city\"> {{(address|async)?.city}}</span>\n    </div>\n    <div>\n      <span> {{(address|async)?.addressSupplement}}</span>\n    </div>\n    <div>\n      <span id=\"country\">{{(address|async)?.countryName}}</span>\n    </div>\n    <div>\n      <span id=\"email\">{{(address|async)?.email}}</span>\n    </div>\n  </div>\n</div>\n",
                styles: [".compact-address-details-container{padding-bottom:30px}.compact-address-details-container .bold{font-weight:700}.compact-address-details-container .address-type{padding-bottom:15px}"]
            }] }
];
/** @nocollapse */
CompactAddressDetailsComponent.ctorParameters = () => [];
CompactAddressDetailsComponent.propDecorators = {
    address: [{ type: Input }],
    addressType: [{ type: Input }],
    isBillingAddress: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactAddressDetailsComponent.prototype.address;
    /** @type {?} */
    CompactAddressDetailsComponent.prototype.addressType;
    /** @type {?} */
    CompactAddressDetailsComponent.prototype.isBillingAddress;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-address-view/compact-address-view.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CompactAddressViewComponent {
    constructor() { }
}
CompactAddressViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-address-view',
                template: "<div class=\"compact-address-container\">\n  <div class=\"title\">\n    <div class=\"row\">\n      <!-- title -->\n      <div class=\"col-lg-6\">\n        <h5>{{ \"modeso_address_compact-address_address\" | injectedText | async }}</h5>\n      </div>\n      \n    </div>\n  </div>\n  <!-- address details -->\n  <modeso-compact-address-details-view id=\"compactDeliveryAddress\"\n    [address]=\"deliveryAddress\" [addressType]=\"'modeso_address_compact-address_delivery-address'\"\n    [isBillingAddress]=\"false\">\n  </modeso-compact-address-details-view>\n  <modeso-compact-address-details-view id=\"compactBillingAddress\" [address]=\"billingAddress\"\n    [addressType]=\"'modeso_address_compact-address_billing-address'\" [isBillingAddress]=\"true\">\n  </modeso-compact-address-details-view>\n\n</div>\n",
                styles: [".compact-address-container{padding-bottom:30px}.compact-address-container h5{font-size:16px;font-weight:700;line-height:20px;margin-bottom:0;margin-top:0}.compact-address-container hr{border-top:.5px solid #d4d1d4;margin-top:10px;margin-bottom:10px}.compact-address-container .title{font-weight:700;padding-bottom:20px}.compact-address-container .title span{border-top:1px solid #bdbbbd}.compact-address-container .address-details{padding-bottom:20px}.compact-address-container .name{font-weight:700}.compact-address-container .address-type{background-color:#eaeaea;padding:10px}"]
            }] }
];
/** @nocollapse */
CompactAddressViewComponent.ctorParameters = () => [];
CompactAddressViewComponent.propDecorators = {
    deliveryAddress: [{ type: Input }],
    billingAddress: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactAddressViewComponent.prototype.deliveryAddress;
    /** @type {?} */
    CompactAddressViewComponent.prototype.billingAddress;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-address-detail-view/compact-address-details-view.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CompactAddressDetailsViewComponent {
    constructor() { }
    /**
     * @param {?} addressModel
     * @return {?}
     */
    set address(addressModel) {
        if (addressModel) {
            this.addressData = addressModel;
            this.setCountryName();
        }
    }
    /**
     * @return {?}
     */
    setCountryName() {
        this.addressData.countryName = AddressUtils.getCountryNameByCode(this.addressData.country);
    }
}
CompactAddressDetailsViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-address-details-view',
                template: "<div class=\"compact-address-details-container\">\n  <div *ngIf=\"isBillingAddress\" class=\"bold address-type\">\n    <span id=\"addressType\">{{addressType | injectedText | async }}</span>\n  </div>\n  <div class=\"address-details\">\n    <div>\n      <span>{{addressData?.company}}</span>\n    </div>\n    <div class=\"bold\">\n      <span id=\"firstName\">{{addressData?.firstName}}</span>\n      <span id=\"lastName\"> {{addressData?.lastName}}</span>\n    </div>\n    <div>\n      <span id=\"street\">{{addressData?.street}}</span>\n      <span id=\"streetNumber\"> {{addressData?.streetNumber}}</span>\n    </div>\n    <div>\n      <span id=\"zipCode\">{{addressData?.zipCode}}</span>\n      <span id=\"city\"> {{addressData?.city}}</span>\n    </div>\n    <div>\n      <span> {{addressData?.addressSupplement}}</span>\n    </div>\n    <div>\n      <span id=\"country\">{{addressData?.countryName}}</span>\n    </div>\n  </div>\n</div>\n",
                styles: [".compact-address-details-container{padding-bottom:30px}.compact-address-details-container .bold{font-weight:700}.compact-address-details-container .address-type{padding-bottom:15px}"]
            }] }
];
/** @nocollapse */
CompactAddressDetailsViewComponent.ctorParameters = () => [];
CompactAddressDetailsViewComponent.propDecorators = {
    address: [{ type: Input }],
    addressType: [{ type: Input }],
    isBillingAddress: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactAddressDetailsViewComponent.prototype.addressData;
    /** @type {?} */
    CompactAddressDetailsViewComponent.prototype.addressType;
    /** @type {?} */
    CompactAddressDetailsViewComponent.prototype.isBillingAddress;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/address.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoAddressModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ModesoAddressModule,
            providers: [AddressService,
                AddressLocalStorageService,
                {
                    provide: ModesoAddressConfigService,
                    useValue: config
                },
            ]
        };
    }
}
ModesoAddressModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AddressDetailsComponent, CompactAddressComponent, AddressComponent,
                    CompactAddressDetailsComponent, CompactAddressViewComponent, CompactAddressDetailsViewComponent],
                providers: [AddressService, AddressLocalStorageService],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    InjectedTextFeautureModule,
                    StoreModule.forFeature(featureKey, reducer),
                    EffectsModule.forFeature([AddressEffects]),
                ],
                exports: [AddressComponent, CompactAddressComponent, CompactAddressViewComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/addressStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$2 = Debug('modeso:lidl-lib-address-fe:AddressStoreProvider');
class AddressStoreProvider {
    /**
     * @param {?} actions$
     * @param {?} store
     * @param {?} addressLocalStorageService
     */
    constructor(actions$, store, addressLocalStorageService) {
        this.actions$ = actions$;
        this.store = store;
        this.addressLocalStorageService = addressLocalStorageService;
        this.canNavigate = new BehaviorSubject(false);
        this.subscriptions = new Subject();
        this.isBillingPosted = false;
        this.isBillingPuted = false;
        this.isDeliveryPosted = false;
        this.isDeliveryPuted = false;
    }
    /**
     * @return {?}
     */
    addressNavigation() {
        this.billingPostAction();
        this.billingPutAction();
        this.deliveryPostAction();
        this.deliveryPutAction();
    }
    /**
     * check billing address marked
     * @return {?}
     */
    isBillingAddress() {
        return this.store.pipe(select(selectIsBillingAddress), map((/**
         * @param {?} isMarked
         * @return {?}
         */
        (isMarked) => {
            return !isMarked;
        })));
    }
    /**
     * When delivery address posted successfully send 'onDeliveryAddressPostedSuccessfully'
     * as parameter tp function checkSuccessStatus
     * @private
     * @return {?}
     */
    deliveryPostAction() {
        this.actions$.pipe(takeUntil(this.subscriptions)).pipe(ofType(onDeliveryAddressPostedSuccessfully.type)).subscribe((/**
         * @return {?}
         */
        () => this.checkSuccessStatus('onDeliveryAddressPostedSuccessfully')));
    }
    /**
     * When delivery address puted successfully send 'onPutDeliveryAddressSuccessfully'
     * as parameter tp function checkSuccessStatus
     * @private
     * @return {?}
     */
    deliveryPutAction() {
        this.actions$.pipe(takeUntil(this.subscriptions)).pipe(ofType(onPutDeliveryAddressSuccessfully.type)).subscribe((/**
         * @return {?}
         */
        () => this.checkSuccessStatus('onPutDeliveryAddressSuccessfully')));
    }
    /**
     * When billing address puted successfully send 'onBillingAddressPostedSuccessfully'
     * as parameter tp function checkSuccessStatus
     * @private
     * @return {?}
     */
    billingPostAction() {
        this.actions$.pipe(takeUntil(this.subscriptions)).pipe(ofType(onBillingAddressPostedSuccessfully.type)).subscribe((/**
         * @return {?}
         */
        () => this.checkSuccessStatus('onBillingAddressPostedSuccessfully')));
    }
    /**
     * When billing address puted successfully send 'onBillingAddressPostedSuccessfully'
     * as parameter tp function checkSuccessStatus
     * @private
     * @return {?}
     */
    billingPutAction() {
        this.actions$.pipe(takeUntil(this.subscriptions)).pipe(ofType(onPutBillingAddressSuccessfully.type)).subscribe((/**
         * @return {?}
         */
        () => this.checkSuccessStatus('onBillingAddressPostedSuccessfully')));
    }
    /**
     * depend on parameter while set special variable to true
     * @private
     * @param {?} actionName
     * @return {?}
     */
    checkSuccessStatus(actionName) {
        switch (actionName) {
            case 'onDeliveryAddressPostedSuccessfully':
                this.isDeliveryPosted = true;
                break;
            case 'onPutDeliveryAddressSuccessfully':
                this.isDeliveryPuted = true;
                break;
            case 'onBillingAddressPostedSuccessfully':
                this.isBillingPosted = true;
                break;
            case 'onBillingAddressPostedSuccessfully':
                this.isBillingPuted = true;
                break;
            default:
                break;
        }
        /**
         * if there is billing address check check status of post or put billing or delivery address
         * if there is not billing address check status of post or put delivery address
         */
        this.isBillingAddress().subscribe((/**
         * @param {?} isBillingAddress
         * @return {?}
         */
        isBillingAddress => {
            if (isBillingAddress) {
                if (this.checkBillingAndDeliveryAddressStatus()) {
                    this.canNavigate.next(true);
                }
                else {
                    this.canNavigate.next(false);
                }
            }
            else {
                if (this.checkDeliveryAddressStatus()) {
                    this.canNavigate.next(true);
                }
                else {
                    this.canNavigate.next(false);
                }
            }
        }));
    }
    /**
     * This is in case there is billing address
     * return true if post or put delivery address successfuly and post or put
     * billing address successfuly.
     * @return {?}
     */
    checkBillingAndDeliveryAddressStatus() {
        return ((this.isDeliveryPosted || this.isDeliveryPuted) && (this.isBillingPosted || this.isBillingPuted));
    }
    /**
     * This is in case there is no billing address.
     * return true if post or put delivery address successfuly.
     * @return {?}
     */
    checkDeliveryAddressStatus() {
        return ((this.isDeliveryPosted || this.isDeliveryPuted));
    }
    /**
     * return each value to its default statue and unsuvscribe all subscription function.
     * @return {?}
     */
    destroy() {
        this.isBillingPosted = false;
        this.isBillingPuted = false;
        this.isDeliveryPosted = false;
        this.isDeliveryPuted = false;
        this.subscriptions.unsubscribe();
    }
    /**
     * @return {?}
     */
    getDeliveryAddress$() {
        return this.store.pipe(select(selectEntitiesByID, { id: AddressType.DELIVERYADDRESS }));
    }
    /**
     * @return {?}
     */
    getBillingAddress$() {
        // tslint:disable-next-line:max-line-length
        return this.isBillingAddress().pipe(mergeMap((/**
         * @param {?} isBillingAddressSet
         * @return {?}
         */
        (isBillingAddressSet) => {
            if (isBillingAddressSet) {
                return this.store.pipe(select(selectEntitiesByID, { id: AddressType.BILLINGADDRESS }));
            }
            else {
                debug$2('Billing Address is equal to delivery address');
                return this.getDeliveryAddress$();
            }
        })));
    }
}
AddressStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AddressStoreProvider.ctorParameters = () => [
    { type: Actions },
    { type: Store },
    { type: AddressLocalStorageService }
];
/** @nocollapse */ AddressStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function AddressStoreProvider_Factory() { return new AddressStoreProvider(ɵɵinject(Actions), ɵɵinject(Store), ɵɵinject(AddressLocalStorageService)); }, token: AddressStoreProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    AddressStoreProvider.prototype.canNavigate;
    /** @type {?} */
    AddressStoreProvider.prototype.subscriptions;
    /** @type {?} */
    AddressStoreProvider.prototype.isBillingPosted;
    /** @type {?} */
    AddressStoreProvider.prototype.isBillingPuted;
    /** @type {?} */
    AddressStoreProvider.prototype.isDeliveryPosted;
    /** @type {?} */
    AddressStoreProvider.prototype.isDeliveryPuted;
    /**
     * @type {?}
     * @private
     */
    AddressStoreProvider.prototype.actions$;
    /** @type {?} */
    AddressStoreProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    AddressStoreProvider.prototype.addressLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/addressLocalization.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const strings = [
    { 'modeso_address_address-details_optional': '(optional)' },
    { 'modeso_address_address-details_company': 'Firma' },
    { 'modeso_address_address-details_first-name': 'Vorname' },
    { 'modeso_address_address-details_first-name-required': 'Bitte Vorname angeben' },
    { 'modeso_address_address-details_last-name': 'Nachname' },
    { 'modeso_address_address-details_last-name-required': 'Bitte Nachname angeben' },
    { 'modeso_address_address-details_street': 'Strasse' },
    { 'modeso_address_address-details_street-required': 'Bitte Strasse angeben' },
    { 'modeso_address_address-details_street-number': 'Nr.' },
    { 'modeso_address_address-details_street-number-required': 'Bitte Nr. angeben' },
    { 'modeso_address_address-details_address-supplement': 'Adresszusatz' },
    { 'modeso_address_address-details_zip-code': 'PLZ' },
    { 'modeso_address_address-details_zip-code-required': 'Bitte PLZ angeben' },
    { 'modeso_address_address-details_city': 'Ort' },
    { 'modeso_address_address-details_city-required': 'Bitte Ort angeben' },
    { 'modeso_address_address-details_country': 'Land' },
    { 'modeso_address_address-details_email': 'E-Mail' },
    { 'modeso_address_address-details_email-required': 'Bitte gültige E-Mail angeben' },
    { 'modeso_address_address_delivery-billing': 'Lieferung und Rechnung gehen an ' },
    { 'modeso_address_address_same-address': 'dieselbe Adresse' },
    { 'modeso_address_address_required-msg': 'prüfen Sie die markierten Felder.' },
    { 'modeso_address_compact-address_address': 'Adressdaten' },
    { 'modeso_address_compact-address_address': 'Adressdaten' },
    { 'modeso_address_compact-address_delivery-address': 'Lieferadresse' },
    { 'modeso_address_compact-address_billing-address': 'Rechnungsanschrift' },
];
class AddressLocalizationProvider {
    /**
     * @param {?} injectedTextProvider
     */
    constructor(injectedTextProvider) {
        this.injectedTextProvider = injectedTextProvider;
        /** @type {?} */
        const defaultStrings = new Array();
        strings.forEach((/**
         * @param {?} element
         * @return {?}
         */
        (element) => {
            /** @type {?} */
            const x = new NamedString(Object.keys(element)[0], element[Object.keys(element)[0]]);
            defaultStrings.push(x);
        }));
        this.setInjectedText(defaultStrings);
    }
    /**
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.injectedTextProvider.setInjectedText(injectedText);
    }
}
AddressLocalizationProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AddressLocalizationProvider.ctorParameters = () => [
    { type: InjectedTextProvider }
];
/** @nocollapse */ AddressLocalizationProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function AddressLocalizationProvider_Factory() { return new AddressLocalizationProvider(ɵɵinject(InjectedTextProvider)); }, token: AddressLocalizationProvider, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AddressLocalizationProvider.prototype.injectedTextProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-address-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AddressLocalizationProvider, AddressModel, AddressStoreProvider, ModesoAddressConfigService, ModesoAddressModule, AddressDetailsComponent as ɵa, CompactAddressComponent as ɵb, onAddressBillingByIdLoadingFailed as ɵba, putDeliveryAddress as ɵbb, onPutDeliveryAddressSuccessfully as ɵbc, onPutDeliveryAddressFailed as ɵbd, putBillingAddress as ɵbe, onPutBillingAddressSuccessfully as ɵbf, onPutBillingAddressFailed as ɵbg, deleteBillingAddress as ɵbh, onDeleteAddressBillingSuccessfully as ɵbi, onDeleteAddressBillingFailed as ɵbj, onIsBillingAddressMarked as ɵbk, AddressEffects as ɵbl, AddressLocalStorageService as ɵc, featureKey as ɵd, adapter as ɵe, selectAddressId as ɵf, sortById as ɵg, initialState as ɵi, reducer as ɵj, AddressComponent as ɵk, CompactAddressDetailsComponent as ɵl, CompactAddressViewComponent as ɵm, CompactAddressDetailsViewComponent as ɵn, AddressService as ɵo, postDeliveryAddress as ɵp, onDeliveryAddressPostedSuccessfully as ɵq, onDeliveryAddressPostingFailed as ɵr, postBillingAddress as ɵs, onBillingAddressPostedSuccessfully as ɵt, onBillingAddressPostingFailed as ɵu, getDeliveryAddressById as ɵv, onAddressDeliveryByIdLoadedSuccessfully as ɵw, onAddressDeliveryByIdLoadingFailed as ɵx, getBillingAddressById as ɵy, onAddressBillingByIdLoadedSuccessfully as ɵz };
